const reorderArrayItem = <T>(
  entities: T[],
  startIndex: number,
  endIndex: number
): T[] => {
  const result = entities;
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default reorderArrayItem;